import snsAxiosClient from '../common/http/http-sns';
import { get, invoke, isEmpty, random, range } from 'lodash';

function getAutoSuggestKeyWords(environmentVariables, searchKeyword) {
  const options = {
    headers: {
      ...environmentVariables.AUTO_SUGGEST_API_HEADERS_GET,
    },
  };

  const params = new URLSearchParams();
  if (!isEmpty(searchKeyword)) {
    params.append('q', searchKeyword);
    params.append('visitorId', invoke(window, 'AB.COMMON.getCookie', 'absVisitorId'));
    params.append('request_id', Math.floor(1000000000000 + Math.random() * 9000000000000).toString());
  }
  return snsAxiosClient(options).get(`${environmentVariables.SNS_AUTOSUGGEST_KEYWORDS}`, {
    params,
  });
}

export default getAutoSuggestKeyWords;
